export default {
  // 视频详情、短视频详情接口
  getVideoDetailById: '/member/anonymous/amc/getVideoContentById',
}